import * as actions from "./actionsType";

const initialData = {
  loading: false,
  saveLoading: false,
  competenciesLength: 0,
  competencies: [],
  competencyError: "",
  formError: "",
};

export default function CompetencyReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COMPETENCY:      
      return { ...state, loading: action.payload };

    case actions.SAVE_LOADING_COMPETENCY:
      return { ...state, saveLoading: action.payload };

    case actions.GET_COMPETENCY:
      return {
        ...state,
        competencies: action.payload.competencies,
        competenciesLength: action.payload.competenciesLength,
      };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.COMPETENCY_FAIL:
      return { ...state, competencyError: action.payload };

    default:
      return state;
  }
}
